import { OBJECT_TYPE_ASSETS } from '@iconik-io/iconik-api/src/types/object_types';
import type { AssetEntityNormalized } from '@iconik-io/shared-lib/src/redux/entities/normalized/asset';

import ContextMenu from '../../components/context_menu/context_menu';
import contextMenuConnector from '../../components/context_menu/context_menu_connector';
import type {
  ContextMenuItemDefinition,
  GetDefinition,
} from '../../components/context_menu/types';
import {
  TRANSCRIBE_CONFIRM_MODAL,
  TRANSCRIPTIONS_EDIT_SPEAKERS,
  TRANSCRIPTIONS_EDIT_SUBTITLES,
} from '../../constants/modals';
import {
  SHARE_ASSET_PAGE_ROUTE,
  SHARE_ASSET_VERSION_PAGE_ROUTE,
} from '../../constants/routes';
import {
  CONTEXT_MENU_GEARBOX_ASSET_TRANSCRIPTIONS,
  connectContextMenuConsumer,
} from '../../contexts/context_menu';
import {
  downloadTranscriptionsCsv,
  downloadTranscriptionsSrt,
  downloadTranscriptionsTextBySegment,
  downloadTranscriptionsTextBySpeaker,
  downloadTranscriptionsVtt,
} from '../../ducks/asset_transcriptions/thunks';
import { openModal } from '../../ducks/modals_manager/slice';
import type { AppDispatch } from '../../store/types';
import { selectUserRoles } from '../../utils/get_user_roles';
import { addObjectType } from '../../utils/object_type';

export const getDefinition: GetDefinition<AssetEntityNormalized> = (
  props,
  state,
) => {
  const [contextItem] = props.contextItems;
  const items: ContextMenuItemDefinition[] = [];
  const userRoles = selectUserRoles(state);

  let canDownload = true;
  // On share page treat allow download as a permission for downloading transcriptions
  if (
    [SHARE_ASSET_PAGE_ROUTE, SHARE_ASSET_VERSION_PAGE_ROUTE].includes(
      state.routeParams.route,
    )
  ) {
    canDownload =
      userRoles.webCanDownloadOriginal || userRoles.webCanDownloadProxy;
  }

  if (userRoles.canTranscribeContent) {
    const contextItems = [
      addObjectType(
        {
          ...contextItem,
        },
        OBJECT_TYPE_ASSETS,
      ),
    ];
    items.push({
      label: 'Transcribe',
      action: () => (dispatch: AppDispatch) =>
        dispatch(
          openModal({
            id: TRANSCRIBE_CONFIRM_MODAL,
            contextItems,
          }),
        ),
    });
  }

  if (window.PLATFORM === 'WEB' && canDownload) {
    items.push({
      label: 'Download as Text',
      action: () => (dispatch: AppDispatch) => {
        if (state.assetTranscriptions.speakerMode) {
          dispatch(downloadTranscriptionsTextBySpeaker(contextItem.id));
        } else {
          dispatch(downloadTranscriptionsTextBySegment(contextItem.id));
        }
      },
    });

    items.push({
      label: 'Download as WebVTT',
      action: () => (dispatch: AppDispatch) =>
        dispatch(downloadTranscriptionsVtt(contextItem.id)),
    });

    items.push({
      label: 'Download as SRT',
      action: () => (dispatch: AppDispatch) =>
        dispatch(downloadTranscriptionsSrt(contextItem.id)),
    });

    items.push({
      label: 'Download as CSV',
      action: () => (dispatch: AppDispatch) => {
        dispatch(downloadTranscriptionsCsv(contextItem.id));
      },
    });
  }

  if (userRoles.canWriteTranscriptions && contextItem?.type !== 'SUBCLIP') {
    items.push({
      label: 'Manage Speakers…',
      action: () => (dispatch: AppDispatch) =>
        dispatch(openModal({ id: TRANSCRIPTIONS_EDIT_SPEAKERS })),
    });
  }

  if (userRoles.canWriteTranscriptions) {
    items.push({
      label: 'Manage Subtitles…',
      action: () => (dispatch: AppDispatch) =>
        dispatch(openModal({ id: TRANSCRIPTIONS_EDIT_SUBTITLES })),
    });
  }

  return {
    items,
  };
};

const AssetTranscriptionsGearboxContextMenu = connectContextMenuConsumer(
  contextMenuConnector(getDefinition)(ContextMenu),
  CONTEXT_MENU_GEARBOX_ASSET_TRANSCRIPTIONS,
);

export default AssetTranscriptionsGearboxContextMenu;
